import { notification } from 'antd';
import axios from 'axios';

const AxiosClient = axios.create({
  baseURL: '/landing/v1.0',
  headers: {
    'Content-Type': 'application/json',
  },
});

function isTokenExpired(token) {
  if (!token) return true;

  const payload = JSON.parse(atob(token.split('.')[1]));
  const exp = payload.exp;

  const now = Date.now() / 1000; // đổi sang giây
  return exp < now;
}

// Interceptors
// Add a request interceptor
AxiosClient.interceptors.request.use(
function (config) {
    const token = localStorage.getItem("token");
    // dùng
  // if (isTokenExpired(token)) {
  //   notification.success({
  //       message: "Thất bại",
  //       description: "Phiên đăng nhập hết hạn!",
  //       placement: "bottomRight",
  //     });
  // } else {
  //   console.log("Token còn hạn");
  // }

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  function (error) {
    // Do something with request error
    console.log(error)
    return Promise.reject(error);
  }
);

// Add a response interceptor
AxiosClient.interceptors.response.use(

  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    console.log(response)
    if(response?.status === 201){

      notification.success({
        message: "Thành công",
        description: "Tạo mới bất động sản thành công!",
        placement: "bottomRight",
      });
    }

    if(response?.status === 202){

      notification.success({
        message: "Thành công",
        description: "Chỉnh sửa bất động sản thành công!",
        placement: "bottomRight",
      });
    }

    if(response?.status === 204){

      notification.success({
        message: "Thành công",
        description: "Xóa bất động sản thành công!",
        placement: "bottomRight",
      });
    }

    return response.data;
  },
  function (error) {
    const {data, status} = error.response
    console.log(data, status)

    if (status === 500){
      console.log(data)
      if (data && data.detail){
        alert(data.detail)
      }
    }

    if(status === 404){
      notification.error({
        message: "Thất bại",
        description: "Không tìm thấy dữ liệu!",
        placement: "bottomRight",
      });
    }
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    // const { config, status, data } = error.response;
    // const URLS = ['/auth/local/register', '/auth/local'];
    // if (URLS.includes(config.url) && status === 400) {
    //   const errorList = data.data || [];
    //   const firstError = errorList.length > 0 ? errorList[0] : {};
    //   const messageList = firstError.messages || [];
    //   const firstMessage = messageList.length > 0 ? messageList[0] : {};
    //   throw new Error(firstMessage.message);
    // }

    // alert("Error")
    // return Promise.reject(error);
  }
);

export default AxiosClient;